import { default as React, useEffect, useState, ReactNode } from 'react';
import { useStyletron, styled } from 'baseui';
import { useGlobalAppLoadingBar } from '../../shared/hooks/useGlobalAppLoadingBar';
import { SpinnerIcon } from '../SpinnerIcon/SpinnerIcon';

interface BasePageLoaderProps<T = any> {
    loading?: boolean
    entity?: T | undefined
    error?: any,
    mountChildrenAfterLoad?: boolean;
    showLoaderContent?: boolean;
    updateGlobalAppLoadingBar?: boolean;
    children?: ReactNode | null | ((entity: T) => ReactNode | null);
    minHeight?: string
}

type PageLoaderProps<T = any> =
    (BasePageLoaderProps<T> & {
        loading: boolean
        // children?: ReactNode | null | ((entity: any) => ReactNode | null);
    }) |
    (BasePageLoaderProps<T> & {
        entity: T | undefined
    })


const Loader = styled<{ $minHeight?: string }, 'div'>('div', ({ $minHeight }) => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    display: 'flex',
    background: 'white',
    transition: 'all 300ms linear',
    zIndex: 10,
    alignItems: 'center',
    justifyContent: 'center',
    padding: $minHeight ? undefined : '100px 50px',
    boxSizing: 'border-box',
}));

export function AsyncMountLoader<T = any>({
                                              entity,
                                              children,
                                              mountChildrenAfterLoad,
                                              showLoaderContent,
                                              updateGlobalAppLoadingBar = true,
                                              loading,
                                              minHeight
                                          }: PageLoaderProps<T>) {
    const [mountLoad, setMountLoad] = useState<boolean>(true);
    const [loadFinished, setLoadFinished] = useState<boolean>(false);
    const [css] = useStyletron();
    const { setValue } = useGlobalAppLoadingBar();

    const loadingMode = typeof loading === 'boolean';
    const shouldRender = loadingMode ? !loading : !!entity;

    const transitionContainer = css({
        zIndex: 0,
    });

    function maybeUpdateGlobalLoadingBar(val: boolean) {
        if (updateGlobalAppLoadingBar)
            setValue(val);
    }

    useEffect(() => {
        if (mountLoad && !shouldRender) {
            setMountLoad(false);
            maybeUpdateGlobalLoadingBar(true);

            setTimeout(() => {
                setLoadFinished(true);
                maybeUpdateGlobalLoadingBar(false);
            }, 200);
        } else if (mountLoad && shouldRender) {
            setLoadFinished(true);
            maybeUpdateGlobalLoadingBar(false);
        }
    }, [shouldRender]);

    const renderChild = () => {
        if (typeof children === 'function') {
            return mountChildrenAfterLoad
                ? shouldRender && children(entity as T)
                : children(entity as T);
        }

        return mountChildrenAfterLoad ? (shouldRender && children) : children;
    };

    return (
        <div>
            <div
                className={transitionContainer}
                style={{
                    position: 'relative',
                    minHeight: minHeight,
                    // ...loadFinished
                    //     ? { minHeight: 'unset' }
                    //     : {},
                }}
            >
                <Loader $minHeight={minHeight} style={{
                    ...loadFinished
                        ? { opacity: 0, zIndex: -1 }
                        : {},
                }}>
                    {
                        showLoaderContent && (
                            <SpinnerIcon/>
                        )
                    }
                </Loader>
                <div>
                    {renderChild()}
                </div>
            </div>
        </div>
    );
}
